/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.programs.combos.list.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.api',
  'acme.common.service.helpers',
  'acme.common.service.calendar',
  'acme.common.service.validate',
  'acme.common.service.permissions',
  'acme.common.factory.notice',
  'acme.view.application.programs.combos.removeModal.controllers',
  'acme.view.application.programs.combos.createModal.controllers',
  'acme.common.factory.gridState',
  'acme.common.service.userPreferences'
])

.controller('ProgramsCombosListController', ['$scope', '$state', '$timeout', '$filter', '$uibModal', 'HelpersService', 'ApiService', 'PermissionsService', 'CalendarService', 'ValidateService', 'NoticeFactory', 'GridStateFactory', 'UserPreferencesService', function($scope, $state, $timeout, $filter, $uibModal, HelpersService, ApiService, PermissionsService, CalendarService, ValidateService, NoticeFactory, GridStateFactory, UserPreferencesService) {

    $scope.programsCombosList = {

      model: [],
      filtered: [],
      lastSearchQuery: '',
      searchQuery: '',
      isLoaded: false,
      createModal: {},
      removeModal: {},
      notice: new NoticeFactory(),
      gridState: new GridStateFactory(),
      dateFormat: UserPreferencesService.getDateFormat('fieldDate', 'dateFormat'),
      grid : {
        multiselect: false,
        enableRowSelection: false,
        paginate: true,
        pageSize: 50,
        showFooter: true,
        rowHeight: 32,
        useExternalPagination: true,
        useExternalSorting: true,
        totalItems: 0,
        columnDefs: [
          {
            field: 'edit',
            displayName: 'Edit',
            width: 50,
            onCellNavClick: function(row, col) {
              $scope.programsCombosList.onGridDblClick(row);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a data-permit="COMBO_TEMPLATE_UPDATE" data-ng-click="grid.appScope.onGridDblClick(row)" role="link">Edit<span class="sr-only"> Details for {{ row.entity.name }}</span></a></div>',
            visible: true,
            enableHiding: false,
            enableSorting: false
          },
          {
            field: 'id',
            displayName: 'Combo Id',
            visible: false
          },
          {
            field: 'name',
            displayName: 'Name'
          },
          {
            field: 'displayDescription',
            displayName: 'Description'
          },
          {
            field: 'dates',
            displayName: 'Dates'
          },
          {
            field: 'status',
            displayName: 'Status'
          }
        ]
      },

      init: function() {
        $scope.$emit('Application::contentTitleChange', {
          title: 'Combos',
          buttonRight: {
            label: '+ Create Combo',
            permissions: 'COMBO_TEMPLATE_CREATE',
            action: function() {
              $scope.programsCombosList.create();
            }
          }
        });

        if (PermissionsService.check('COMBO_TEMPLATE_DELETE')) {
          this.grid.columnDefs.push({
            field: 'remove',
            displayName: 'Remove',
            onCellNavClick: function(row, col) {
              $scope.programsCombosList.remove(row.entity.id);
            },
            cellTemplate: '<div class="ui-grid-cell-contents"><a class="programs-combos-link programs-combos-link-remove" data-ng-click="grid.appScope.remove(row.entity.id)" role="button">Remove<span class="sr-only">-Opens a dialog</span></a></div>'
          });
        }

        this.gridState.updateGridState(null, this.grid.pageSize, 'name', 'asc');

        this.getProgramsCombosList();
      },
      
      getProgramsCombosList: function () {
        var props = Object.assign({}, this.gridState.getGridState(), { summary: true });
        ApiService.combo.templates.list(props).then(this.success.getProgramsCombosList, this.error.getProgramsCombosList);
      },

      hasCombos: function() {
        return (this.model instanceof Array && this.model.length > 0);
      },

      findCombo: function(id) {
        var i, ii,
            r = false;

        for (i=0,ii=this.model.length;i<ii;i++) {
          if (this.model[i].id === id) {
            r = {
              index: i,
              instance: this.model[i]
            };
            break;
          }
        }

        return r;
      },

      search: function() {
        this.filtered = $filter('filter')(this.model, function(combo) {
          var name = (combo.name && combo.name.length > 0) ? combo.name : '',
              description = (combo.description && combo.description.length > 0) ? combo.description : '',
              value = (name + description).toLowerCase();

          return (value.indexOf($scope.programsCombosList.searchQuery.toLowerCase()) !== -1) ? combo : null;
        });
      },

      create: function() {
        var self = $scope.programsCombosList;

        self.createModal = $uibModal.open({
          templateUrl: 'views/application/views/programs/combos/modals/createCombo.tpl.html',
          size: 'md',
          controller: 'ProgramsCombosCreateModalController',
          resolve: {
            combosList: function() {
              return self.model;
            }
          }
        });

        // Invoked when modal completes with close(params)
        self.createModal.result.then(function (combo) {
          self.notice.hideSuccessMessages();
          self.notice.hideErrorMessages();
          ApiService.combo.templates.create(combo).then(self.success.create, self.error.create);
        }, function () {
          // Do nothing
        });

      },

      remove: function(id) {
        var self = $scope.programsCombosList,
            combo = self.findCombo(id);

        if (combo) {

          self.removeModal = $uibModal.open({
            templateUrl: 'views/application/views/programs/combos/modals/removeCombo.tpl.html',
            size: 'md',
            controller: 'ProgramsCombosRemoveModalController',
            resolve: {
              currentCombo: function() {
                return combo.instance;
              }
            }
          });

          // Invoked when modal completes with close(params)
          self.removeModal.result.then(function (name) {
            self.notice.hideSuccessMessages();
            self.notice.hideErrorMessages();

            self.model.splice(combo.index, 1);
            self.search();
            ApiService.combo.templates.remove(combo.instance.id).then(function () {
              self.getProgramsCombosList();
            }, self.error.remove);
          }, function () {
            // Do nothing
          });

        }
      },

      process: function(combos) {
        var i, ii,
            status,
            endTime,
            startTime,
            endDiff = 0,
            startDiff = 0,
            today = new Date(),
            minutes = (1000 * 60),
            hours = (minutes * 60),
            days = (hours * 24);

        for (i=0,ii=combos.length;i<ii;i++) {
          status = 'Incomplete';
          endTime = CalendarService.parseDate(combos[i].endTime);
          startTime = CalendarService.parseDate(combos[i].startTime);

          combos[i].dates = $filter('date')(startTime, this.dateFormat);
          combos[i].dates += ' - ';
          combos[i].dates += $filter('date')(endTime, this.dateFormat);
          combos[i].displayDescription = (combos[i].shortDescription) ? HelpersService.strip(combos[i].shortDescription, 80) : HelpersService.strip(combos[i].description, 80);

          // Make sure the combo is complete before testing its status
          if (combos[i].priceList || combos[i].discountId) {
            console.log('ProgramsCombosListController::process', combos[i].priceList, combos[i].discountId);

            endDiff = (today.getTime() - endTime.getTime()) / minutes;
            startDiff = (today.getTime() - startTime.getTime()) / minutes;

            if (startDiff < 1) {
              status = 'Not started';
            }else if (endDiff > 1) {
              status = 'Expired';
            }else{
              status = 'Active';
            }
          }
          combos[i].status = status;
        }

        return combos;

      },

      success: {
        init: function(response) {
        },
        create: function(response) {
          $state.go('application.programs.combos.edit.description', { comboId: response.data.payload.id });
        },
        remove: function(response) {},
        
        getProgramsCombosList: function (response) {
          var self = $scope.programsCombosList;
          self.model = self.process(response.data.payload.list);
          self.grid.totalItems = response.data.payload.pagination.count;
          self.search();
          self.isLoaded = true;
        }
      },

      error: {
        init: function(response) {},
        remove: function(response) {},
        create: function(response) {},
        getProgramsCombosList: function (response) {}
      },

      onGridDblClick: function(item) {
        if (PermissionsService.check('COMBO_TEMPLATE_UPDATE')) {
          // Create and edit are handled by the same controller
          console.log('ProgramsCombosListController::onGridDblClick', item.entity.id);
          $state.go('application.programs.combos.edit.description', { comboId: item.entity.id });
        }
      },

      onDataGridPaginate: function(newPage, pageSize) {
        var self = $scope.programsCombosList;
        self.gridState.updateGridState(newPage, pageSize);
        self.getProgramsCombosList();
      },

      onDataGridSortChange: function(grid, columns) {
        var self = $scope.programsCombosList, data = columns[0];
        if(data) {
          self.gridState.updateGridState(null, null, data.field, data.sort.direction);
          self.getProgramsCombosList();
        }
      }
      

    };

    $scope.programsCombosList.init();

}]);